import SingleMediaMessage from './SingleMediaMessage';
export default SingleMediaMessage;
